<template>
    <div class="schtable-container">
        <div class="schtable">
            <div v-for="(item,index) in tableList" class="list-table" :key="index">
                <div class="list-time">
                    <div class="start-time">{{item.START_DATE}}</div>
                    <div class="start-time">{{item.END_DATE}}</div>
                </div>
                <div class="list-info">
                    <div class="list-info-inner"  @click="addItem(item)"></div>
                </div>

            </div>
        </div>
        <div v-for="(item,index) in lists" class="list-data"
             :style="'top:'+calcTop(item.START_DATE)+'px;height:'+calcHeight(item.START_DATE,item.END_DATE)+'px'"
             @click="clickItem(item)"
        >
            <!--预约时间小于半小时 一行显示-->
            <div class="list-data-inner" :class="calcTime(item.START_DATE,item.END_DATE) == 1?'':'oneline'">
                <div class="list-type">{{item.TYPE}}<span v-if="item.TYPE=='FAE'">申请人：{{item.APPLY_NAME}}</span></div>
                <div class="list-remark" :class="showInfo(item)?'':'hide'">{{item.REMARK}}</div>
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: "schTable",
        props: {
            lists: Array,
            isSchedule: {
                type: Number,
                default: 0,
            },
            searchDate: String,
            faeId: String,
            faeDatas: Object,
            dateFormat:String
        },
        data() {
            return {
                tableList: [
                    {
                        START_DATE: '8',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '9',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '10',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '11',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '12',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '13',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '14',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '15',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '16',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '17',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '18',
                        END_DATE: ""
                    },
                    {
                        START_DATE: '19',
                        END_DATE: ""
                    },
                ],

                bosArrName: [],    // 特殊权限的人群，从快码配置并关联的TEMP_CUSTOMER的字段
                isBoss: false, // 当前用户是否是特殊权限的人群
                subArrIds: [],     // 下属
                source: ''
            }
        },
        mounted(){
            try {
                this.bosArrName = JSON.parse(localStorage.getItem('BOSS_NAME'));
                this.subArrIds = JSON.parse(localStorage.getItem('USER_Subordinate_FORMAT'));

                let userName = JSON.parse(localStorage.getItem('LS_ADMIN')).USER_ACCOUNT; // 当前用户 英文名
                this.isBoss = this.bosArrName.includes(userName);
            } catch (e) {

            }

            if (this.CoreNew.WEB_URL_SOURCE) {
                this.source = this.CoreNew.WEB_URL_SOURCE
            }
        },
        methods: {
            /**
             *  显示规则如下：
             *  1.只有FAE类型
             *  2.当前用户是 被预约的FAE
             *  3.当前用户是 申请人
             *  4.当前用户是 被预约的FAE 的领导
             *  5.当前用户是 申请人 的领导
             *  6.当前用户是快码配置里配置的数据 用户名
             *   isFAEBoss: false, // 当前用户是否是FAE的BOSS
             *   isApplyBoss: false, // 当前用户是否是申请人的BOSS
             * */
            showInfo(item) {
                if (item.TYPE == 'FAE') {
                    let userId = JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID')); // 当前用户
                    let applyId = item.APPLY_ID; // 申请人
                    let faeId = item.FAE_EMP;    // FAE

                    if (userId == applyId || userId == faeId || this.isBoss || this.subArrIds.includes(applyId) || this.subArrIds.includes(faeId)) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },

            calcTop(sTime) {
                let time_start = sTime.split(" ")[1].split(":");
                let vtop = 60;
                let htime = parseInt(time_start[0]),
                    mtime = parseInt(time_start[1]);
                return vtop * (htime-8) + mtime
            },
            calcHeight(sTime, eTime) {
                eTime = eTime.replace(/-/g,'/')
                sTime = sTime.replace(/-/g,'/')
                let h = (new Date(eTime).getTime() - new Date(sTime).getTime())/1000/60;
                return h
            },
            // 计算是否小于半小时
            calcTime(sTime, eTime){
                eTime = eTime.replace(/-/g,'/')
                sTime = sTime.replace(/-/g,'/')
                let h = new Date(eTime).getTime() - new Date(sTime).getTime();
                if( h <= 1000*60*30 ){
                    return 0
                }else {
                    return 1
                }
            },
            addItem(item){
                if(this.isSchedule){
                    this.addSchedule(item.START_DATE)
                }else{
                    this.addFAE(item.START_DATE)
                }
            },
            clickItem(item) {
                if (item.TYPE == 'FAE') {
                    let userId = JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID')); // 当前用户
                    let applyId = item.APPLY_ID; // 申请人
                    let faeId = item.FAE_EMP;    // FAE

                    if (userId == applyId || userId == faeId || this.isBoss || this.subArrIds.includes(applyId) || this.subArrIds.includes(faeId)) {
                        this.showFAE(item.ID)
                    } else {
                        this.$toast("您的权限貌似不够哦！");
                    }
                } else if (item.TYPE == '日程') {
                    this.showSchedule(item.ID)
                }
            },

            showFAE(id){
                this.$router.push({
                    path: '/fae/edit',
                    query: {
                        entityId: id,
                        type: 'see',
                        isSchedule: this.isSchedule,
                        dateFormat:this.dateFormat,
                        source: this.source,
                    }
                })
            },
            showSchedule(id) {
                this.$router.push({
                    path: '/schedule/addSchedule',
                    query: {
                        entityId: id,
                        type: 'see',
                        dateFormat:this.dateFormat,
                        source: this.source,
                    }
                })
            },

            editFAE(id) {
                // this.$emit('editData',id);
                this.$router.push({
                    path: '/fae/edit',
                    query: {
                        entityId:id,
                        type: 'edit',
                        dateFormat:this.dateFormat,
                        source: this.source,
                    }
                })
            },
            addFAE(startTime) {
                this.$router.push({
                    path: '/fae/edit',
                    query: {
                        id: this.faeId,
                        name: this.faeDatas.NAME,
                        ename: this.faeDatas.ENAME,
                        date: this.searchDate,
                        sdate: startTime,
                        type: 'add',
                        origin: 'detail',
                        dateFormat:this.dateFormat,
                        source: this.source,
                    }
                })
            },
            addSchedule(startTime){
                this.$router.push({
                    path: '/schedule/addSchedule',
                    query: {
                        date: this.searchDate,
                        sdate: startTime,
                        type: 'add',
                        dateFormat:this.dateFormat,
                        source: this.source,
                    }
                })
            },
        }
    }
</script>


<style scoped lang="less">
    .schtable-container {
        position: relative;
        overflow: hidden;

        .schtable {
            position: relative;

            .list-table {
                display: flex;
                align-content: center;
                justify-content: center;
                position: relative;

                .list-time {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    font-size: 10px;
                    border-right: 2px solid #eee;
                    padding: 10px 10px 20px 10px;
                    width: 30px;
                    height: 30px;
                }

                .list-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    font-size: 12px;
                    .list-info-inner{
                        width: 100%;
                        height: 100%;
                    }
                }


            }

            .list-table::after {
                position: absolute;
                left: 0;
                bottom: -1px;
                content: '';
                background: #ddd;
                width: 100%;
                height: 1px;

            }
        }

        .schtable-list {
            position: absolute;
            width: 80%;
            height: 100%;
            top: 0;

        }
        .list-data {
            position: absolute;
            left: 60px;
            font-size: 12px;
            background: rgba(33, 150, 243, .8);
            color: #fff;
            overflow: hidden;
            outline:1px solid #fff;
            z-index: 10;
            width: 80%;

            .list-data-inner {
                padding: 5px 10px;
                .list-remark{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .list-data-inner.oneline{
                display: flex;
                .list-remark{
                    flex: 1;
                    margin-left: 5px;
                }
            }
        }
    }
</style>